import Event from '../domain/Event.js';

let MYEFC_AUTH_COOKIE_NAME = 'myEfcCookieAuth';

class EmailCaptureHandler {

  constructor(controller, emailAddressValidator, requestBuilder, httpService, trackingService, cookieUtils, utils, locale) {

    this.controller = controller;
    this.emailAddressValidator = emailAddressValidator;
    this.requestBuilder = requestBuilder;
    this.httpService = httpService;
    this.trackingService = trackingService;
    this.cookieUtils = cookieUtils
    this.utils = utils
    this.locale = locale;

  }

  handleSubmit(emailAddress) {

    this.controller.startActionInProgress();

    this.controller.setState({
      formInProgress: 'CAPTURE_EMAIL'
    });

    this.emailAddressValidator.validate(emailAddress);

    this.trackingService.submitEvent(Event.EMAIL_COLLECTION_SUBMISSION);

    let registrationFlowRequest = this.requestBuilder.getRegistrationFlowRequest(emailAddress);

    return this.httpService.get(registrationFlowRequest)
      .then((response) => {
        return this.handleRegistrationFlowResponse(emailAddress, response.data);
      });

  }

  handleRegistrationFlowResponse(emailAddress, registrationFlowResponseData) {

    if (registrationFlowResponseData !== undefined) {

      if (registrationFlowResponseData.require_registration) {

        return registerNewUser.bind(this)(emailAddress);

      } else if (registrationFlowResponseData.require_unblock) {

        return this.controller.showBlockedAccountPage();

      } else if (registrationFlowResponseData.require_unlock) {

        return this.controller.showLockedAccountPage();

      } else if (registrationFlowResponseData.require_verify) {

        return processUnverifiedAccount.bind(this)(emailAddress);

      } else if (registrationFlowResponseData.require_password) {

        return processAccountWithoutPassword.bind(this)(emailAddress);

      } else {

        this.controller.showLoginPage();

        return;

      }

    }

  }

}

let registerNewUser = function (emailAddress) {

  let registrationBody = {
    email_address: emailAddress,
    locale: this.locale
  };
  let registrationRequest = this.requestBuilder.getRegistrationRequest(registrationBody);

  return this.httpService.post(registrationRequest)
    .then((response) => {
      this.cookieUtils.set(MYEFC_AUTH_COOKIE_NAME, response.data.access_token, {domain: this.utils.getCookieDomain(), path: '/'});
      this.trackingService.submitEvent(Event.ACCOUNT_CREATION, {emailAddress: emailAddress});
      this.controller.handleSuccess(response.data);

      return response;
    });

};

let processUnverifiedAccount = function (emailAddress) {

  let requestVerificationEmailRequest = this.requestBuilder.getRequestVerificationEmailRequest(emailAddress);

  return this.httpService.get(requestVerificationEmailRequest)
    .then((response) => {
      this.controller.showVerifiedEmailSentPage(response.data);

      return response;
    });

};

let processAccountWithoutPassword = function (emailAddress) {

  let requestResetPasswordEmailRequest = this.requestBuilder.getRequestResetPasswordEmailRequest(emailAddress);

  return this.httpService.get(requestResetPasswordEmailRequest)
    .then((response) => {
      this.controller.showResetPasswordConfirmationPage(response.data);

      return response;
    });

};

export default EmailCaptureHandler;



// WEBPACK FOOTER //
// ./src/library/handlers/EmailCaptureHandler.js